import axios from 'axios';
import { URL } from './base.api';

const utilsApi = axios.create({
    baseURL: `${URL}/Utils`,
    //headers: {'Content-Type':'application/json','Access-Control-Allow-Origin':'*','Access-Control-Allow-Methods':'GET,POST,OPTIONS,DELETE,PUT'}
})

export const getIsAlive = () => utilsApi.get('/')